module.exports = __webpack_public_path__ + "media/img/kanban/kanban-1-39d801c2d5e4c1a3f88b1563e1a26d79.jpg";